/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import { getBlockRenderer } from '../registry/blockRegistry';
export function SubscriptionPreviewRenderer({ block }) {
    var _a;
    const preview = block;
    const effectiveLimit = Math.min(Math.max(0, (_a = preview.preview_limit) !== null && _a !== void 0 ? _a : 50), 50);
    const items = Array.isArray(preview.preview_content) ? preview.preview_content.slice(0, effectiveLimit) : [];
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: `Preview (${items.length} of ${preview.total_results} results)`,
                content: React.createElement(Text, { variant: "body" }, preview.message)
            }
        ] }, items.map((child, idx) => {
        var _a;
        const Renderer = getBlockRenderer(child.type);
        return Renderer ? React.createElement(Renderer, { key: (_a = child.block_id) !== null && _a !== void 0 ? _a : idx, block: child }) : null;
    })));
}
